<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Add Site</h4>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <form>
          <div class="form-group">
            <label for="txtSiteName">Name</label>
            <input type="text" class="form-control" id="txtSiteName" v-model="site.name">
          </div>
          <div class="form-group" v-if="machine_type === 'Box'">
            <label for="txtSiteName">Alt Name</label>
            <input type="text" class="form-control" id="txtSiteAltName" v-model="site.alt_name">
            <small class="form-text text-muted">Useful if custom DNS entries are setup to point to this machine, does not affect SIP device registration.</small>
          </div>
          <div class="form-group">
            <label for="txtDomainName">IP</label>
            <input type="text" class="form-control" id="txtDomainName" v-model="site.ip">
          </div>
          <div class="form-group">
            <label for="txtExtensionPrefix">Extension Prefix</label>
            <input type="text" class="form-control" id="txtExtensionPrefix" v-model="site.extension_prefix">
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()">Submit</button>
          <router-link :to="{ name: 'AdminSiteIndex' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: function () {
    return {
      site: {
        site_id: 0,
        name: '',
        alt_name: '',
        ip: '',
        top_level: false,
        extension_prefix: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      site: 'singleSite',
      machine_type: 'machineType'
    })
  },
  methods: {
    submit () {
      this.$store.dispatch('addEditSite', this.site)
    }
  }
}
</script>

<style scoped>

</style>
